

class CalendarInfo {
    public date: Date = new Date();
}

import CalendarEvent, { ConvertCalendarEventToAttribute } from "../../../shared/CalendarEvent";
import Attribute from "../../../shared/Attribute";
import Vue from "vue";
import { World } from "../../../shared/World";
import { data } from "@/App.vue";

const barColors = ["gray", "red", "orange", "yellow", "green", "teal", "blue", "indigo", "purple", "pink"];

export default Vue.extend({
    name: "Calendar",
    computed: {

        baseEvents: {
            cache: false,
            get(): CalendarEvent[] {
                const result: CalendarEvent[] = [];

                const startYear = new Date().getFullYear();
                const endYear = startYear + 5;
                let colorIndex = 0;

                // Auto generate events from the world settings
                if (data.Settings && data.Settings.Worlds) {
                    for (const worldKey of Object.keys(data.Settings.Worlds)) {

                        const world = data.Settings.Worlds[worldKey];

                        let start_day = world.start_day;
                        let start_month = world.start_month;
                        let end_day = world.end_day;
                        let end_month = world.end_month;
                        let seasonalName = world.managerName;

                        // Prehistoria is a special case
                        if (worldKey === "prehistoria") {
                            seasonalName = world.seasonalVariant;
                            start_day = 1;
                            start_month = 4;
                            end_day = 30;
                            end_month = 4;
                        }

                        // This is a sesonal world
                        if (start_day && end_day && start_month && end_month) {

                            for (let year = startYear; year <= endYear; year++) {

                                const startDay = new Date(year, start_month - 1, start_day);
                                const endDay = new Date(year, end_month - 1, end_day);
                                // Must be a year in the future?
                                if (endDay < startDay) {
                                    endDay.setFullYear(endDay.getFullYear() + 1);
                                }

                                const event = new CalendarEvent();
                                event.startingDate = startDay;
                                event.endingDate = endDay;
                                event.label = "Seasonal game: " + seasonalName;
                                event.worlds.push(worldKey);
                                event.color = barColors[colorIndex];


                                result.push(event);
                            }

                            colorIndex = (colorIndex + 1) % barColors.length;
                        }
                    }
                }

                return result;
            }
        },

        attributes: {
            cache: false,
            get(): Attribute[] {
                const result: Attribute[] = [];

                for (const event of this.baseEvents) {
                    result.push(ConvertCalendarEventToAttribute(event));
                }

                return result;
            }
        },
        events: {
            cache: false,
            get(): CalendarEvent[] {
                const result: CalendarEvent[] = [];

                for (const event of this.baseEvents) {

                    let anyMatch = false;

                    const thisDate = new Date(event.startingDate.getTime());
                    while (thisDate <= event.endingDate) {
                        if (thisDate.getDate() === this.date.getDate()
                            && thisDate.getFullYear() === this.date.getFullYear()
                            && thisDate.getMonth() === this.date.getMonth()) {
                            anyMatch = true;
                            break;
                        }
                        thisDate.setDate(thisDate.getDate() + 1);
                    }

                    if (anyMatch) {
                        result.push(event);
                    }
                }
                return result;
            }
        }
    },
    data() {
        return new CalendarInfo();
    },
    methods: {
        getWorldData(id: string): World {
            if (!data.Settings) {
                return new World();
            }
            return data.Settings.Worlds[id];
        }
    }
});

